import * as React from "react";
import { SVGProps } from "react";
const SvgHomeAddSolution = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#home-add-solution_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m31.9 15.56-5.83-12a1 1 0 0 0-.9-.56H6.83a1 1 0 0 0-.9.56l-5.83 12A1 1 0 0 0 1 17h4v10a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V17h4a1 1 0 0 0 .9-1.44ZM25 17v9H7V15H2.6L7.46 5h17.08l4.86 10H25v2Zm-8.319-6.228a.955.955 0 0 1 .272.683v3.591h3.591a.956.956 0 1 1 0 1.909h-3.591v3.591a.956.956 0 1 1-1.909 0v-3.591h-3.591a.956.956 0 1 1 0-1.909h3.591v-3.591a.966.966 0 0 1 1.637-.683Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="home-add-solution_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHomeAddSolution;
